import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import Home from "../views/Home.vue";
import Login from "../views/Login";
import ForgetPassword from "@views/Login_forgetPassword.vue";
import Register from "../views/Register";
import Authentication from "@views/Authentication.vue";
import MapServiceAgreement from "@views/MapServiceAgreement.vue";


//个人中心
import UserCenter from "../views/userCenter"

//套件新增页面
import Price from "../views/Price";
import Purchase from "../views/Purchase";
import Process from "../views/Process";
import Contract from "../views/Contract";
import Payment from "../views/Payment";
import MyRSservice from "../views/MyRSservice";
import RSsserviceManage from "../views/RSsserviceManage";
// import Instruction from "../views/Instruction";
import MyRSservices from "../views/MyRSservices";
import Feedback from "../views/Feedback";
import viewMapSource from "../views/viewMapSource";
import ProcessRep from "../views/ProcessRep";
import CountyPrices from "../views/CountyPrices";
import Login_mobile from "@views/mobile/Login_mobile.vue";
import CountyPrices_Tool from "../views/CountyPrices_Tool";
//区县图新增页面
import demandConfirm from "../views/county/demandConfirm";
import demandSubmit from "../views/dataPack/demandSubmit";
import countyContract from "../views/county/countyContract";
import buyCountyProduction from "@views/county/buyCountyProduction.vue";
import rsOrderDetail from "@views/county/rsOrderDetail.vue";
import rsOrderPayment from "@views/county/rsOrderPayment.vue";
import rsOrderAppraise from "@views/county/rsOrderAppraise.vue"
//外业移动核查
import auditor from '@views/fieldVerification/auditor.vue'
import examine from '@views/fieldVerification/examine.vue'
//新版套件使用项目
import imageSegmentation from "@views/imageSegmentation.vue";
import vectoryLibrary from "@views/vectoryLibrary.vue"
import cooperateMarkEnter from "@views/newProject/cooperateMarkEnter.vue"
import createProject from "@views/newProject/createProject.vue";
import markerTask from "@views/newProject/markerTask.vue";
import checkerTask from "@views/newProject/checkerTask.vue"
import fieldWorkEnter from "@views/newProject/fieldWorkEnter.vue"
import fieldWorkCreateProject from "@views/newProject/fieldWorkCreateProject.vue";
import wyMobileDownload from "@views/newProject/wyMobileDownload.vue";
//标准版套件，新增
import demandConfirm_standard from "@views/county/demandConfirm_standard.vue";
import standardContract from "../views/standard/standardContract";
import standardOrderPayment from "../views/standard/standardOrderPayment";
import rsStandardOrderDetail from "../views/standard/rsStandardOrderDetail.vue"
import standardOrderAppraise from "@views/standard/standardOrderAppraise.vue";
//流量包
import rsManage from "@views/dataPack/rsManage.vue";
import purchaseData from "@views/dataPack/GeneralTraffic/purchaseData.vue";
import generalHome from "@views/dataPack/GeneralTraffic/Home.vue";
import annualPurchaseData from "@views/dataPack/AnnualPurchase/purchaseData.vue";
import annualSubmitOrder from "@views/dataPack/AnnualPurchase/submitOrder.vue";
import annualHome from "@views/dataPack/AnnualPurchase/Home.vue";
import orderDetail from "@views/dataPack/orderDetail.vue";
//在线客服
import serviceHome from "../components/onlineService/Home.vue";



Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  base:"/rskit",
  mode: "history",
  routes: [
    // {
    //   path:'/standardOrderAppraise',
    //   name:'standardOrderAppraise',
    //   component: standardOrderAppraise
    // },
    {
      path:'/rsStandardOrderDetail',
      name:'rsStandardOrderDetail',
      component: rsStandardOrderDetail
    },
    // {
    //   path:'/standardOrderPayment',
    //   name:'standardOrderPayment',
    //   component: standardOrderPayment
    // },
    // {
    //   path:'/standardContract',
    //   name:'standardContract',
    //   component: standardContract
    // },
    {
      path:'/demandConfirm_standard',
      name:'demandConfirm_standard',
      component: demandConfirm_standard
    },
      //新版套件项目应用
    {
      path:'/wyMobileDownload',
      name:'wyMobileDownload',
      component: wyMobileDownload
    },
    {
      path:'/fieldWorkCreateProject',
      name:'fieldWorkCreateProject',
      component: fieldWorkCreateProject
    },
    {
      path:'/fieldWorkEnter',
      name:'fieldWorkEnter',
      component: fieldWorkEnter
    },
    {
      path:'/markerTask',
      name:'markerTask',
      component: markerTask
    },
    {
      path:'/checkerTask',
      name:'checkerTask',
      component: checkerTask
    },
    {
      path:'/createProject',
      name:'createProject',
      component: createProject
    },
    {
      path:'/imageSegmentation',
      name:'imageSegmentation',
      component: imageSegmentation
    },
    {
      path: '/vectoryLibrary',
      name:'vectoryLibrary',
      component: vectoryLibrary
    },
    {
      path: '/cooperateMarkEnter',
      name:'cooperateMarkEnter',
      component: cooperateMarkEnter
    },
      //切片套件购买标准化
    // {
    //   path:"/rsOrderAppraise",
    //   name:"rsOrderAppraise",
    //   component:rsOrderAppraise,
    // },
    {
      path:"/rsOrderPayment",
      name:"rsOrderPayment",
      component:rsOrderPayment,
    },
    {
      path:"/buyCountyProduction",
      name:"buyCountyProduction",
      component:buyCountyProduction,
    },
    {
      path:"/rsOrderDetail",
      name:"rsOrderDetail",
      component:rsOrderDetail,
    },
    {
      path:"/ForgetPassword",
      name:"ForgetPassword",
      component:ForgetPassword,
    },
    //个人中心
    {
      path: "/UserCenter",
      name: "UserCenter",
      component: UserCenter,
    },
    // 新首页
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/Authentication",
      name: "Authentication",
      component: Authentication,
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
    },
    {
      path: "/Register",
      name: "Register",
      component: Register,
    },
    //在线访问产品使用协议
    {
      path: "/MapServiceAgreement",
      name: "MapServiceAgreement",
      component: MapServiceAgreement,
    },
    // {
    //   path: "/Price",
    //   name: "Price",
    //   component: Price,
    // },
    // {
    //   path: "/Purchase",
    //   name: "Purchase",
    //   component: Purchase,
    // },
    // {
    //   path: "/Process",
    //   name: "Process",
    //   component: Process,
    // },
    // {
    //   path: "/Contract",
    //   name: "Contract",
    //   component: Contract,
    // },
    // {
    //   path: "/Payment",
    //   name: "Payment",
    //   component: Payment,
    // },
    {
      path: "/MyRSservice",
      name: "MyRSservice",
      component: MyRSservice,
    },
    {
      path: "/RSsserviceManage",
      name: "RSsserviceManage",
      component: RSsserviceManage,
    },
    // {
    //   path: "/Instruction",
    //   name: "Instruction",
    //   component: Instruction,
    // },
    {
      path: "/MyRSservices",
      name: "MyRSservices",
      component: MyRSservices,
    },

    {
      path: "/Feedback",
      name: "Feedback",
      component: Feedback,
    },
    {
      path: "/viewMapSource",
      name: "viewMapSource",
      component: viewMapSource,
    },
    // {
    //   path: "/ProcessRep",
    //   name: "ProcessRep",
    //   component: ProcessRep,
    // },
    // {
    //   path: "/CountyPrices",
    //   name: "CountyPrices",
    //   component: CountyPrices,
    // },
    // {
    //   path: "/CountyPrices_Tool",
    //   name: "CountyPrices_Tool",
    //   component: CountyPrices_Tool,
    // },
    {
      path: "/Login_mobile",
      name: "Login_mobile",
      component: Login_mobile,
    },
    {
      path: "/demandConfirm",
      name: "demandConfirm",
      component: demandConfirm,
    },
    {
      path: "/demandSubmit",
      name: "demandSubmit",
      component: demandSubmit,
    },
    {
      path: "/countyContract",
      name: "countyContract",
      component: countyContract,
    },
    {
      path: "/auditor",
      name: "auditor",
      component: auditor,
    },
    {
      path: "/examine",
      name: "examine",
      component: examine
    },
    //流量包
    {
      path: "/rsManage",
      name: "rsManage",
      component: rsManage
    },
    {
      path: "/GeneralTraffic/purchaseData",
      name: "purchaseData",
      component: purchaseData
    },
    {
      path: "/GeneralTraffic/Home",
      name: "generalHome",
      component: generalHome
    },
    {
      path: "/AnnualPurchase/annualPurchaseData",
      name: "annualPurchaseData",
      component: annualPurchaseData
    },
    {
      path: "/AnnualPurchase/annualSubmitOrder",
      name: "annualSubmitOrder",
      component: annualSubmitOrder
    },
    {
      path: "/AnnualPurchase/Home",
      name: "annualHome",
      component: annualHome
    },
    {
      path: "/orderDetail",
      name: "orderDetail",
      component: orderDetail
    },
    {
      path: "/onlineService/Home",
      name: "serviceHome",
      component: serviceHome
    },
    
    //其他输入都进入404中
    {
      path: "/404",
      component: () => import("@/views/exception/404"),
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  localStorage.setItem("preRoute", router.currentRoute.fullPath)
  //每个页面的停留时间相关函数
  let stayTime=null;
  // 记录新页面开始时间
  let newPageStartTime = new Date().getTime();
  if(window.sessionStorage.getItem('logLastStart')&&(to.path!=from.path)){
    stayTime=((newPageStartTime-window.sessionStorage.getItem('logLastStart'))/1000).toFixed(2);
  }
  //将页面开始访问时间保存，作为下一个页面计算上一页面持续时间的起点
  window.sessionStorage.setItem('logLastStart', newPageStartTime)
  let token=getKey()
  if(token){
    token="Bearer "+token;
  }
  if(stayTime==''||stayTime=='null'){
    stayTime=0
  }
  let param = new FormData()  // 创建form对象
  param.append('currentUrl','/rskit'+to.path)  // 通过append向form对象添加数据
  param.append('fromUrl','/rskit'+from.path)
  param.append('eventType', '0')
  param.append('stayTime', stayTime)
  console.log("路由守卫")
  console.log(to.path,from.path)
  axios.post('https://www.jl1mall.com/loginapi/log/addOperationLog', param,
      {headers: {
          Authorization: token,
        }}).then(res => {
    console.log('pv统计')
    console.log(res)
  })
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function () {
      document.getElementById("baidu_tj") &&
        document.getElementById("baidu_tj").remove();
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?dd1580c04617bb7a7575d022eda32336";
      hm.id = "baidu_tj";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    var _paq = _paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);
    (function () {
      var u = "//analytics.escience.org.cn/";
      _paq.push(["setTrackerUrl", u + "piwik.php"]);
      _paq.push(["setSiteId", "34"]);
      var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.type = "text/javascript";
      g.async = true;
      g.defer = true;
      g.src = u + "piwik.js";
      s.parentNode.insertBefore(g, s);
    })();
  }, 0);
});

function getCookie(cname) {
  return localStorage.getItem(cname);
}
function getKey() {
  return localStorage.getItem("token");
}
export default router;
